export const KPI_KEYS = [
  "unresolvedAidRequests",
  "fullOpportunities",
  "untreatedOpportunities",
  "closedRate",
  "avgTimeToFull",
  "activeOpportunities",
  "urgentOpportunities",
  "totalOpportunities",
] as const;

export type KpiKey = (typeof KPI_KEYS)[number];
export type KpiPopupVariant = "breakdown" | "avgTimeDistribution";

export const KPI_POPUP_VARIANT: Record<KpiKey, KpiPopupVariant> = {
  unresolvedAidRequests: "breakdown",
  fullOpportunities: "breakdown",
  untreatedOpportunities: "breakdown",
  closedRate: "breakdown",
  avgTimeToFull: "avgTimeDistribution",
  activeOpportunities: "breakdown",
  urgentOpportunities: "breakdown",
  totalOpportunities: "breakdown",
};

export const KPI_META: Record<
  KpiKey,
  { dialogTitle: string; explanation: string; }
> = {
  unresolvedAidRequests: {
    dialogTitle: "בקשות סיוע פתוחות",
    explanation:
      "משימות עם סטטוס בקשת סיוע שעדיין לא נסגרו. החלוקה מחושבת לפי קישורי אוכלוסייה, פרויקטים וקטגוריות - משימה אחת יכולה להופיע ביותר ממקטע אחד, ולכן סכום המקטעים עלול לעלות על מספר המשימות המוצג בכרטיס.",
  },
  fullOpportunities: {
    dialogTitle: "משימות מלאות",
    explanation:
      "כמו בטבלת המשימות (לשונית \"מלאות\"): משימות פתוחות שאינן בקשות סיוע, שבהן סומן מלא או שמספר המשתתפים המאושרים (יחידים + קבוצות) מגיע ל־amount. החלוקה לפי קישורים; משימה עם מספר קטגוריות נספרת בכל קטגוריה.",
  },
  untreatedOpportunities: {
    dialogTitle: "משימות שלא טופלו",
    explanation:
      "כמו בטבלת המשימות (לשונית \"לא טופלו\"): משימות פתוחות שאינן בקשות סיוע, לא מלאות, ושאחד מהתנאים מתקיים: קריאה אחרונה למתנדבים עד היום, או תאריך התחלה עד היום, או תאריך סיום עד היום. החלוקה לפי קישורי אוכלוסייה, פרויקט וקטגוריה.",
  },
  closedRate: {
    dialogTitle: "הרכב משימות סגורות",
    explanation:
      "רק משימות שנסגרו שאינן בקשות סיוע. מציגים כיצד המשימות הסגורות מתפלגות לפי אוכלוסייה, פרויקט וקטגוריה (לפי קישורים במערכת).",
  },
  avgTimeToFull: {
    dialogTitle: "התפלגות זמן מאצ׳",
    explanation:
      "זמן מאצ׳ ממוצע: מרגע אישור הבקשה (או יצירת משימה ישירה) ועד למתנדב או קבוצה ראשונה מאושרת. נכללות רק משימות פתוחות או מלאות (כמו בטבלת המשימות) שיש להן לפחות מתנדב אחד. ציר ה-X מציג טווחי זמן מהיר לאיטי, וציר ה-Y מציג את מספר המשימות בכל טווח.",
  },
  activeOpportunities: {
    dialogTitle: "משימות פעילות",
    explanation:
      "כמו בטבלת המשימות (לשונית \"פתוחות\"): משימות פתוחות שאינן בקשות סיוע, עם מקום להרשמה לפי מספר המשתתפים המאושרים (יחידים + קבוצות) מול amount, ובתנאי התאריכים והקריאה האחרונה כמו בטבלה. החלוקה לפי קישורים; סכום מקטעים עשוי לעלות על מספר המשימות בגלל קישורים מרובים.",
  },
  urgentOpportunities: {
    dialogTitle: "משימות דחופות",
    explanation:
      "משימות פתוחות שאינן בקשות סיוע, עם דחיפות קריטית. החלוקה לפי אוכלוסייה, פרויקט וקטגוריה.",
  },
  totalOpportunities: {
    dialogTitle: "כל המשימות בסינון",
    explanation:
      "כל המשימות שאינן בקשות סיוע, לפי הסינון (ללא מחיקה). החלוקה לפי קישורים; משימה עם מספר קטגוריות או אוכלוסיות מופיעה בכמה מקטעים.",
  },
};
